import { useEffect, useState } from 'react'
import { Modal, Spinner } from 'react-bootstrap'
import Button from 'react-bootstrap/Button'
import FloatingLabel from 'react-bootstrap/FloatingLabel'
import Form from 'react-bootstrap/Form'
import { FaTrash } from 'react-icons/fa'
import { HiOutlineXMark } from 'react-icons/hi2'
import { components } from 'react-select'
import CreatableSelect from 'react-select/creatable'
import swal from 'sweetalert'
import { useAddChildMutation, useUpdateChildMutation } from '../redux/api/childApi'
import { useAddSpecialityMutation, useDeleteSpecialityMutation, useGetSpecialityQuery } from '../redux/api/specialityApi'
import Formstyle from './cssModule/Formstyle.module.css'
import s from './cssModule/children.module.css'
import { useSelector } from 'react-redux'

const FormModal = ({ formData, setFormData, isEdit, show, setShow }) => {
  const [validated, setValidated] = useState(false)
  const [speciality, setSpeciality] = useState(null)

  const { userToken } = useSelector((state) => state.auth)

  const { data: specialities, isLoading: isLoadingSpecialities } = useGetSpecialityQuery()
  const [deleteSpeciality, { isLoading: isDeletingSpec }] = useDeleteSpecialityMutation()
  const [addSpeciality, { isLoading: isAddingSpec }] = useAddSpecialityMutation()

  const [addChild, { isLoading: isAdding, isError: isAddError, error: addError }] = useAddChildMutation()
  const [updateChild, { isLoading: isUpdating, isError: isUpdateError, error: updateError }] = useUpdateChildMutation()

  const hasError = isAddError || isUpdateError
  const errorMessage = updateError?.data?.error || addError?.data?.error

  useEffect(() => {
    if (!isLoadingSpecialities && specialities.length > 0) {
      const initialOption = specialities.find((option) => option.value === formData.special_need)
      setSpeciality(initialOption)
    }
  }, [isLoadingSpecialities, specialities, formData.special_need])

  const handleCreate = async (inputValue) => {
    await addSpeciality({ newSpeciality: inputValue.toLowerCase().trim() })
  }

  const handleChange = (e) => {
    const { name, value } = e.target
    setFormData({ ...formData, [name]: value })
  }

  const handleSubmit = async (e) => {
    e.preventDefault()

    if (e.currentTarget.checkValidity() === false) {
      e.stopPropagation()
      return
    }

    if (!formData?.special_need) {
      return
    }

    if (isEdit) {
      await updateChild({ ...formData, userid: formData.user_uid, person_uid: userToken }).unwrap()
      await swal({ title: 'Good job!', text: 'User Updated Successfully', icon: 'success' })
    } else {
      await addChild({ ...formData, person_uid: userToken }).unwrap()
      await swal({ title: 'Good job!', text: 'User Added Successfully', icon: 'success' })
    }

    setShow(false)
    setValidated(true)
  }

  const customStyles = {
    container: (provided, state) => ({
      ...provided,
      fontFamily: 'soraregular',
      width: '100%',
    }),
    valueContainer: (provided, state) => ({
      ...provided,
      padding: 0,
      margin: 0,
    }),
    input: (provided, state) => ({
      ...provided,
      padding: 0,
      margin: 0,
    }),
    placeholder: (provided, state) => ({
      ...provided,
      padding: 0,
      margin: 0,
    }),
    control: (provided, state) => ({
      ...provided,
      padding: 0,
      border: 'none',
      borderBottom: state.isFocused ? '2px solid var(--primary-color)' : '2px solid #ebebeb',
      borderRadius: 'none',
      boxShadow: 'none',
      '&:hover': {
        borderBottom: '2px solid #ebebeb',
      },
    }),
    disabled: (provided) => ({
      ...provided,
      borderBottom: '2px solid #ebebeb', // Light gray border color for disabled state
    }),
  }

  const customOption = (props) => {
    const { data } = props

    const handleDelete = async (e) => {
      e.stopPropagation()
      await deleteSpeciality({ id: data.value })
      setFormData((old) => ({ ...old, special_need: '' }))
    }

    return (
      <components.Option {...props}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <span>{data.label}</span>
          <button onClick={handleDelete} disabled={isDeletingSpec} className='border-0 p-0 bg-transparent bg-danger bg-opacity-25'>
            <FaTrash className='text-danger' />
          </button>
        </div>
      </components.Option>
    )
  }

  const handleSpecialityChange = (selectedOption) => {
    setSpeciality(selectedOption)
    setFormData((old) => ({ ...old, special_need: selectedOption?.value || '' }))
  }

  return (
    <>
      <Modal show={show} onHide={() => setShow((s) => !s)} className='FormModal'>
        {/* <Modal.Header closeButton /> */}
        <Modal.Body className='px-4 py-5 position-relative'>
          <div className=' position-absolute end-0 top-0 p-2 me-3 mt-3'>
            <HiOutlineXMark size={36} className={`${s.closeBtn}`} onClick={() => setShow((s) => !s)} />
          </div>
          <Form noValidate validated={validated} onSubmit={handleSubmit}>
            {hasError && <p className='text-danger'>{errorMessage}</p>}

            <FloatingLabel controlId='floatingInput' label='ID' className={Formstyle.labelinput}>
              <Form.Control required type='text' placeholder='age' maxLength='50' name='username' onChange={handleChange} value={formData.username} />
              <Form.Control.Feedback type='invalid'>Please enter required field.</Form.Control.Feedback>
            </FloatingLabel>

            <Form.Group className='mb-3'>
              <Form.Label htmlFor='gender'>Gender</Form.Label>
              <br />
              <Form.Check
                required
                type='radio'
                label='Male'
                id='Male'
                name='gender'
                value='male'
                checked={formData.gender === 'male'}
                onChange={handleChange}
                inline
              />
              <Form.Check
                required
                type='radio'
                label='Female'
                id='Female'
                name='gender'
                value='female'
                checked={formData.gender === 'female'}
                onChange={handleChange}
                inline
              />
              <Form.Check
                required
                type='radio'
                label='Prefer Not To Say'
                id='Prefer Not To Say'
                name='gender'
                value='prefer_not_to_say'
                checked={formData.gender === 'prefer_not_to_say'}
                onChange={handleChange}
                inline
              />
              <Form.Control.Feedback type='invalid'>Please enter required field.</Form.Control.Feedback>
            </Form.Group>

            <FloatingLabel controlId='dob' label='Date of Birth' className='mb-3'>
              <Form.Control required type='date' name='dob' value={formData.dob} onChange={handleChange} />
              <Form.Control.Feedback type='invalid'>Please enter required field.</Form.Control.Feedback>
            </FloatingLabel>

            <label>Profession</label>
            <CreatableSelect
              isClearable
              isDisabled={isAddingSpec}
              isLoading={isAddingSpec}
              value={speciality}
              onChange={handleSpecialityChange}
              onCreateOption={handleCreate}
              options={specialities}
              styles={customStyles}
              placeholder='Start typing to add options'
              formatCreateLabel={(inputValue) => `Press enter to add '${inputValue}'`}
              components={{ Option: customOption }}
              className='mb-3'
            />

            <Button variant='primary' className='common-btn full-btn m-0' type='submit' disabled={isAdding || isUpdating}>
              {isAdding || isUpdating ? (
                <div className='d-flex align-items-center justify-content-center gap-2'>
                  <Spinner animation='border' /> {isEdit ? 'Updating' : 'Adding'}
                </div>
              ) : isEdit ? (
                'Update User'
              ) : (
                'Add User'
              )}
            </Button>
          </Form>
        </Modal.Body>
      </Modal>
    </>
  )
}
export default FormModal
